import { defineMessages } from 'react-intl';

export default defineMessages({
  shopOnlinePaymentAlert: {
    id: 'app.modules.shopDetails.shopHeader.shopOnlinePaymentAlert',
    defaultMessage: 'Pagá online en este local',
  },
});
